<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col
          lg="8"
          md="10"
          sm="12"
          offset-lg="2"
          offset-md="1"
          offset-sm="0"
          class="transcribe-file-container">
          <b-row class="mt-3">
            <b-col cols="12">
              <h4 class="text-center">{{$t('createJob.title')}}</h4>
            </b-col>
          </b-row>
          <b-form novalidate @submit.stop.prevent="createJob">
            <b-row class="mt-3">
              <b-col sm="12" md="6">
                <b-form-group
                  id="file-input-group"
                  :label="$t('createJob.fileUploadLabel')"
                  label-for="file-input"
                >
                  <b-form-file
                    id="file-input"
                    name="file"
                    accept="audio/*, video/*"
                    v-model="file"
                    v-validate="{required: true}"
                    :state="validateState('file')"
                  >
                  </b-form-file>

                  <b-form-invalid-feedback>
                    {{$t('createJob.fileUploadInvalid')}}
                  </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group
                  id="additional-keywords-input-group"
                  :label="$t('createJob.additionalKeywordsLabel')"
                  :description="$t('createJob.additionalKeywordsDescription')"
                  label-for="additional-keywords-input"
                >
                  <b-form-textarea
                    id="additional-keywords-input"
                    class="additional-keywords-input"
                    v-model="additionalKeywords"
                    rows="3"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="6">
                <b-form-group
                  id="job-name-input-group"
                  :label="$t('createJob.jobNameLabel')"
                  label-for="job-name-input"
                >
                  <b-form-input
                    type="text"
                    id="job-name-input"
                    name="job-name"
                    v-model="jobName"
                    v-validate="{required: true}"
                    :state="validateState('job-name')"
                  ></b-form-input>

                  <b-form-invalid-feedback>
                    {{$t('createJob.jobNameInvalid')}}
                  </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group
                  id="input-lang-input-group"
                  :label="$t('createJob.inputLanguageLabel')"
                  label-for="input-lang-input"
                >
                  <b-form-select
                    id="input-lang-input"
                    name="input-lang"
                    v-model="inputLanguage"
                    v-validate="{required: true}"
                    :state="validateState('input-lang')"
                  >
                    <option
                      v-for="supportedLang in supportLanguages"
                      :key="supportedLang.languageCode"
                      :value="supportedLang.languageCode"
                    >
                      {{supportedLang.languageName}}
                    </option>
                  </b-form-select>
                  <b-form-invalid-feedback>
                    {{$t('createJob.inputLanguageInvalid')}}
                  </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group
                  id="desired-lang-input-group"
                  :label="$t('createJob.desiredLanguageLabel')"
                  label-for="desired-lang-input"
                >
                  <b-form-select
                    id="desired-lang-input"
                    name="desired-lang"
                    v-model="desiredLanguage"
                    v-validate="{required: true}"
                    :state="validateState('desired-lang')"
                  >
                    <option
                      v-for="supportedLang in supportLanguages"
                      :key="supportedLang.languageCode"
                      :value="supportedLang.languageCode"
                    >
                      {{supportedLang.languageName}}
                    </option>
                  </b-form-select>
                  <b-form-invalid-feedback>
                    {{$t('createJob.desiredLanguageInvalid')}}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-3 mb-3">
              <b-col cols="12">
                <loading-button
                  :text="$t('createJob.uploadButton')"
                  :loading-text="$t('createJob.uploadButtonLoading')"
                  variant="secondary"
                  :loading="submitting"
                  type="submit"
                  :disabled="veeErrors.any()"
                />
              </b-col>
            </b-row>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import FormValidation from '../../mixins/FormValidation';
  import FormReset from '../../mixins/FormReset';

  export default {
    mixins: [FormValidation, FormReset],
    data() {
      return {
        submitting: false,
        file: null,
        jobName: '',
        inputLanguage: 'en-GB',
        desiredLanguage: 'en-GB',
        additionalKeywords: '',
        supportLanguages: [
          {
            languageCode: 'en-GB',
            languageName: 'English (UK)',
          },
        ],
      };
    },
    methods: {
      createJob() {
        this.$validator.validateAll()
          .then((result) => {
            if (!result) {
              return;
            }
            this.$toasted.info(this.$t('createJob.uploadBegunInfo'));
            this.submitting = true;
            this.$store.dispatch('jobs/createJob', {
              file: this.file,
              name: this.jobName,
              inputLanguage: this.inputLanguage,
              desiredLanguage: this.desiredLanguage,
              additionalKeywords: this.additionalKeywords,
            })
              .then((job) => {
                this.$toasted.success(this.$t('createJob.jobCreated', { name: job.name }));
                this.submitting = false;
                // Clear form
                this.clearForm();
              })
              .catch(() => {
                this.submitting = false;
                this.$toasted.error(this.$t('createJob.errorCreatingJob'));
              });
          });
      },
      clearForm() {
        this.file = null;
        this.jobName = '';
        this.inputLanguage = 'en-GB';
        this.desiredLanguage = 'en-GB';
        this.additionalKeywords = '';
        this.resetForm();
      },
    },
  };
</script>

<style scoped>
  .transcribe-file-container {
    background: white;
    border-radius: 4px;
  }

  .additional-keywords-input {
    max-height: 100px;
  }
</style>
